import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tCentro/Store/CustomHandlerCreator";
import CustomPdpAddToCartVariant from "@tCentro/Store/Reducer/CustomPDPVariantAddToCartState";

type HandlerType = CustomApiHandler<CustomPdpAddToCartVariant, boolean>;
export const CenVariantPdpAddToCartClicked: Handler = (props:any) => {

    props.dispatch({
        type: "Pages/CenProductDetails/CenVariantAddToCartisClicked",
        param: props.parameter.variantPdpAddToCartClicked,
    });
};

export const chain = [CenVariantPdpAddToCartClicked];

const cenVariantPdpAddToCartClicked = createHandlerChainRunnerOptionalParameter(chain, {}, "CenVariantPdpAddToCartClicked");
export default cenVariantPdpAddToCartClicked;
